const entriesTypes = {

  index: {
    request: "ENTRIES_INDEX_REQUEST",
    page_request: "ENTRIES_INDEX_PAGE_REQUEST",
    success: "ENTRIES_INDEX_SUCCESS",
    sorted_request: "ENTRIES_SORTED_INDEX_REQUEST",
    sorted_success: "ENTRIES_SORTED_INDEX_SUCCESS",
    sorted_failure: "ENTRIES_SORTED_INDEX_FAILURE",
    page_success: "ENTRIES_INDEX_PAGE_SUCCESS",
    failure: "ENTRIES_INDEX_FAILURE"
  },

  batch_update: {
    request: "ENTRIES_BATCH_UPDATE_REQUEST",
    success: "ENTRIES_BATCH_UPDATE_SUCCESS",
    failure: "ENTRIES_BATCH_UPDATE_FAILURE",
  },

  dry_batch_update: {
    request: "ENTRIES_DRY_BATCH_UPDATE_REQUEST",
    success: "ENTRIES_DRY_BATCH_UPDATE_SUCCESS",
    failure: "ENTRIES_DRY_BATCH_UPDATE_FAILURE",
    reset: "ENTRIES_DRY_BATCH_RESET"
  },

  // update multiple
  um: {
    request: "ENTRIES_UM_REQUEST",
    success: "ENTRIES_UM_SUCCESS",
    failure: "ENTRIES_UM_FAILURE",
    set_icon: "ENTRIES_SET_OUT_OF_DATE_ICON"
  },

  title_length: {
    show: "SHOW_TITLE_LENGTH_COLUMN",
    hide: "HIDE_TITLE_LENGTH_COLUMN"
  },

  add_columns: {
    request: "ADD_CUSTOM_COLUMNS_REQUEST",
    success: "ADD_CUSTOM_COLUMNS_SUCCESS",
    failure: "ADD_CUSTOM_COLUMNS_FAILURE"
  },

  set_counters: {
    success: "SET_COUNTERS_SUCCESS"
  },

  duplicate_row: {
    request: "DUPLICATE_ROW_REQUEST",
    success: "DUPLICATE_ROW_SUCCESS",
    failure: "DUPLICATE_ROW_FAILURE"
  },

  mark_read: {
    request: "MARK_READ_REQUEST",
    success: "MARK_READ_SUCCESS",
    failure: "MARK_READ_FAILURE"
  },

  publish_row: {
    request: "PUBLISH_ROW_REQUEST",
    success: "PUBLISH_ROW_SUCCESS",
    failure: "PUBLISH_ROW_FAILURE"
  },

  unpublish_row: {
    request: "UNPUBLISH_ROW_REQUEST",
    success: "UNPUBLISH_ROW_SUCCESS",
    failure: "UNPUBLISH_ROW_FAILURE"
  },

  bulk_rows: {
    request: "MULTIPLE_ROWS_REQUEST",
    failure: "MULTIPLE_ROWS_FAILURE"
  },

  multiple_mark_read: {
    success: "MULTIPLE_MARK_READ_SUCCESS",
  },

  multiple_publish: {
    success: "MULTIPLE_PUBLISH_SUCCESS",
  },

  multiple_unpublish: {
    success: "MULTIPLE_UNPUBLISH_SUCCESS",
  },

  set_sorting: "SET_ENTRIES_SORTING",

  set_filters: "SET_ENTRIES_FILTERS",

  reset_errors: "RESET_ENTRY_ERRORS"
  // identical to index
  // add_title_columns: {
  //   request: "ADD_TITLE_COLUMNS_REQUEST",
  //   success: "ADD_TITLE_COLUMNS_SUCCESS",
  //   failure: "ADD_TITLE_COLUMNS_FAILURE"
  // }

}

export default entriesTypes



// WEBPACK FOOTER //
// ./src/js/constants/entriesTypes.js